export const contractsState = {
  name: 'contracts',
  url: '/contracts',
  component: 'contracts',
  data: {
    title: 'Договоры',
  },
}
